<script setup lang="ts">
import DraggerMenuState from "@/stores/DraggerMenuState";
import { Logger } from "@/logger";
import type { Arrayable } from "@vueuse/core";

defineProps<{ vertical?: boolean }>();

function setSmoothen(value: Arrayable<number>) {
  if (typeof value === "number") {
    DraggerMenuState.setSmoothen(value);
    Logger.info(`SmoothenSlider: set to ${value}`);
  } else {
    Logger.warn(`SmoothenSlider: invalid value ${value}`);
  }
}
</script>

<template>
  <el-slider
    :model-value="DraggerMenuState.smoothen"
    @input="(value) => setSmoothen(value)"
    :vertical="vertical"
    :height="vertical ? '150px' : undefined"
    :step="10"
    :min="0"
    :max="100"
  />
</template>
